import React from 'react';
import { FormCard, FormDescriptions, supplierDefs } from '@purchase/supplier';
import AttachmentItem from '../components/AttachmentItem';

const renderAccepted = (accepted?: boolean): string => {
  if (accepted === undefined || accepted === null) return '--';
  return accepted ? '是' : '否';
};

/** 区块6：供应商反馈 */
const VendorFeedbackBlock = ({
  detail,
}: {
  detail?: supplierDefs.VendorFeedbackDto;
}) => {
  return (
    <FormCard title="供应商反馈" proCardProps={{ expandable: true }}>
      <FormDescriptions columns={2} labelStyle={{ width: 180 }} margin={false}>
        <FormDescriptions.Item label="是否接受整改意见">
          <span>{renderAccepted(detail?.accepted)}</span>
        </FormDescriptions.Item>
        <FormDescriptions.Item label="盖章事故报告">
          <AttachmentItem value={detail?.stampedReport} />
        </FormDescriptions.Item>
        <FormDescriptions.Item label="支付凭证">
          <AttachmentItem value={detail?.paymentVoucher} />
        </FormDescriptions.Item>
        <FormDescriptions.Item label="其他附件" span={2}>
          <AttachmentItem value={detail?.otherAttachments} />
        </FormDescriptions.Item>
        <FormDescriptions.Item label="补充说明" span={2}>
          <span className="[word-break:break-word]">{detail?.supplementRemark || '--'}</span>
        </FormDescriptions.Item>
      </FormDescriptions>
    </FormCard>
  );
};

export default VendorFeedbackBlock;
